const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:9004/location-center/api'

export default {
  baseUrl: API_BASE_URL,
  member: {
    login: `${API_BASE_URL}/member/login`,
    register: `${API_BASE_URL}/member/register`,
    checkIn: `${API_BASE_URL}/member/checkin`,
    checkInStatus: `${API_BASE_URL}/member/checkin/status`
  },
  payment: {
    create: `${API_BASE_URL}/payment/create`,
    alipayDemoCreate: `${API_BASE_URL}/alipay/demo/create`,
    alipayDemoStatus: (orderNo) => `${API_BASE_URL}/alipay/demo/status/${orderNo}`
  }
}
